
import { HandleService } from "../../_services";
import { ApiExportedFileConnectedDeviceModel, ApiExportedFilesConnectedDeviceModels, eExportConnectedStatus } from "./ApiExportFileConnectedDeviceModel";
import { ApiExportGroupsDevices } from "../precizion/ApiExportGroupsDevicesModel";
import { isNullOrUndefined } from "../../_helpers";

/**
 * Class grid datas export connecté
 */
export class GridExportsStatesDatas {

    //grid Rows
    public Datas: GridRowExportStateDatas[] = []

    /**
     * Init 
     * @param _iApiExportedFilesConnected les export connectés (back api)
     */
    constructor(_iApiExportedFilesConnected: ApiExportedFilesConnectedDeviceModels | null) {
        this.Datas = [];

        if (_iApiExportedFilesConnected && _iApiExportedFilesConnected.Exists()) {
            _iApiExportedFilesConnected.Exports.forEach((fRow: ApiExportedFileConnectedDeviceModel) => {
                this.Datas.push(new GridRowExportStateDatas(fRow))
            });
            this.OrderingByExportDates();
        }
    }

    /**
     * Complète selon les machines chargée les informations de celle-ci
     * @param _iAllDevices référentiel
     */
    public BindDeviceInfos(_iAllDevices: ApiExportGroupsDevices) {
        if (_iAllDevices?.Exists() && this.Datas?.length > 0) {
            this.Datas.forEach(fData => {
                if (fData.DeviceUID) {
                    let deviceFound = _iAllDevices.GetByUniqueId(fData.DeviceUID);
                    if (deviceFound) {
                        fData.DeviceName = deviceFound.Name ?? "";
                        fData.DeviceAccount = deviceFound?.Account?.Name ?? "";
                        fData.DeviceModel = deviceFound?.Model?.Name ?? "";
                        fData.DeviceManufacturer = deviceFound?.Manufacturer?.Name ?? "";
                        fData.DeviceTooltip = "Modèle : " + fData.DeviceModel;
                        fData.DeviceTooltip += "\n Constructeur : " + fData.DeviceManufacturer;
                        fData.DeviceMissing = false;
                    } else {
                        fData.CheckDeviceMissing(false);
                    }
                }
            });
            this.OrderingByExportDates();

        }
    }

    /**
     * MAJ du statut de device manquante
     * @param _iIsLoadingDevice true les device sont en cours de chargement donc indique ""En cours de chargement"
     */
    public UpdateDeviceMissingStatus(_iIsLoadingDevice: boolean) {
        if (this?.Datas?.length > 0) {
            this.Datas.forEach((fDataExport) => {
                fDataExport.CheckDeviceMissing(_iIsLoadingDevice);
            });
        }
    }

   
    /**
     * Ordonne desc selon date de debut puis date de fin
     */
    private OrderingByExportDates() {
        if (this.Datas?.length > 1) {
            this.Datas.sort((a, b) => {

                const isEmpty = (v: string) => !v || v.trim() === '';

                // --- 1. Gestion des DateStart vides ---
                if (isEmpty(a.DateStart) && !isEmpty(b.DateStart)) return -1;
                if (!isEmpty(a.DateStart) && isEmpty(b.DateStart)) return 1;

                // --- 2. Comparaison DateStart ---
                if (a.DateStart !== b.DateStart) {
                    return a.DateStart > b.DateStart ? -1 : 1;
                }

                // --- 3. Gestion des DateEnd vides ---
                if (isEmpty(a.DateEnd) && !isEmpty(b.DateEnd)) return -1;
                if (!isEmpty(a.DateEnd) && isEmpty(b.DateEnd)) return 1;

                // --- 4. Comparaison DateEnd ---
                if (a.DateEnd !== b.DateEnd) {
                    return a.DateEnd > b.DateEnd ? -1 : 1;
                }

                return 0;
            });
        }
    }

}

/** Class grid row export connecté*/
export class GridRowExportStateDatas {

    /**Nom du fichier */
    public FileName: string = "";
    /**Export requete Uid */
    public ReqUid: string = "";

    /**statut export connecté */
    public StatutText: string = "";

    /**detail statut export connecté */
    public StatutDetails: string = "";
    /**Icone tooltip lié au statut */
    public StatutIconTooltip: string = "";
    /**Icone css liée au statut */
    public StatusIconCss: string = "";
    /**Date de début de traitement */
    public DateStart: string = "";
    /**Date de fin de traitement */
    public DateEnd: string = "";
    /**Si le fichier est dispo au telechargmeent */
    public FileAvailable: boolean = false;

    /**si le fichier est en cours de tranfert */
    public IsInProgress: boolean = false;

    /**tooltip sur icone de téléchagement*/
    public FileDownloadTooltip: string = "";

    //nom de la console (selon si chargé actif)
    public DeviceName: string = "";
    //modèle de la console (selon si chargé actif)
    public DeviceModel: string = "";
    //constructeur de la console (selon si chargé actif)
    public DeviceManufacturer: string = "";
    //nom du compte lié à la console (selon si chargé actif)
    public DeviceAccount: string = "";
    /**id console */
    public DeviceUID: string = "";

    /**tooltip formaté sur le nom de la console (selon si chargé actif)*/
    public DeviceTooltip: string = "";
    /**Indique si la console n est plus présente au référentiel */
    public DeviceMissing: boolean = false;

    /**
     * Init
     * @param _iApiExportedFileConnectedDeviceModel export fichier back api
     */
    constructor(_iApiExportedFileConnectedDeviceModel: ApiExportedFileConnectedDeviceModel) {
        this.ReqUid = _iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.ReqUid ?? "";
        this.FileAvailable = _iApiExportedFileConnectedDeviceModel.FileExporting?.Name !== undefined && _iApiExportedFileConnectedDeviceModel.FileExporting?.Name !== "";

        if (this.FileAvailable) {
            this.FileName = _iApiExportedFileConnectedDeviceModel.FileExporting?.Name ?? "";
            this.FileDownloadTooltip = "Téléchargement du fichier";
        } else {
            this.FileDownloadTooltip = "Téléchargement pas disponible";
        }
        this.DeviceUID = _iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.DeviceUid ?? "";
        this.UpdateStatus(_iApiExportedFileConnectedDeviceModel);
        this.DeviceMissing = false;

    }

    /**
     * Maj du statut affiché ainsi que les textes affichés
     * @param _iApiExportedFileConnectedDeviceModel model export
     */
    public UpdateStatus(_iApiExportedFileConnectedDeviceModel: ApiExportedFileConnectedDeviceModel) {

        this.DeviceMissing = false;
        this.IsInProgress = true;
        if (_iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.SendingAt) {
            this.DateStart = HandleService.ConvertStringTimeFr(_iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.SendingAt);
            if (_iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.SendingEnd) {
                this.DateEnd = HandleService.ConvertStringTimeFr(_iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.SendingEnd);
            }
        }
        let status = 0;
        this.StatutText = "En cours";
        if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.Initial) {
            this.StatutIconTooltip = "En cours de traitement";
            status = 0;
        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.SendingWaiting) {
            this.StatutIconTooltip = "En attente d'envoi vers la console";
            this.StatutText = "Envoi en cours";
            status = 1;
        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.SendingInProgress) {
            this.StatutText = "Envoi en cours";
            this.StatutIconTooltip = "En cours d'envoi vers la console";
            status = 2;
        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.TransfertWaiting) {
            this.StatutText = "Prêt pour transfert";
            this.StatutIconTooltip = "Fichier envoyé sur la plateforme, la console le recevra dés qu'elle sera connectée";
            status = 3;
            if (_iApiExportedFileConnectedDeviceModel.IsFinished == true) {
                status = 13;
            }

        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.TransfertInProgress) {
            this.StatutText = "Transfert en cours";
            this.StatutIconTooltip = "En cours de transfert vers la console";
            status = 4;
            if (_iApiExportedFileConnectedDeviceModel.IsFinished == true) {
                this.StatutIconTooltip = "Transfert terminé";
                this.StatutText = "Terminé";
                status = 5;
            }

        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.Success) {
            this.StatutIconTooltip = "Transfert terminé";
            this.StatutText = "Terminé";
            status = 5;
        } else if (_iApiExportedFileConnectedDeviceModel.Status == eExportConnectedStatus.RejectedByUser) {
            this.StatutIconTooltip = "Transfert réussi mais refusé par l'utilisateur";
            this.StatutText = "Refusé";
            status = 6;
        } else {
            //en echec
            this.StatutIconTooltip = "Echec d'envoi";
            this.StatutText = "Echec";
            status = 7;
        }
        this.IsInProgress = status < 5;

        this.StatusIconCss = "ic-status-" + status;
        this.StatutDetails = _iApiExportedFileConnectedDeviceModel.FileExporting?.Connected.Description ?? "";
        if (_iApiExportedFileConnectedDeviceModel.FileExporting?.IsStillAvailable == false) {
            this.FileAvailable = false;
            this.FileDownloadTooltip = "Téléchargement du fichier plus disponible";
        }

        if (status == 7) {
            if (this.StatutDetails) {
                this.StatutIconTooltip += "\n" + this.StatutDetails;
            }
        }
    }

    /**
     *  Contrôle les device manquant asterisk rouge
     * @param _iIsLoadingDevice true les device sont en cours de chargement donc indique ""En cours de chargement"
     */
    public CheckDeviceMissing(_iIsLoadingDevice: boolean = false) {
        this.DeviceMissing = ((this.DeviceName == "" || this.DeviceName == "!") && this.DeviceAccount == "");

        if (this.DeviceMissing) {
            this.DeviceName = "!";
            this.DeviceTooltip = _iIsLoadingDevice ? "En cours de chargement" : "Console désactivée";
        }
    }

}

